module.exports = __webpack_public_path__ + "static/media/8OLA27.33ff501f.jpg";